import React from 'react'

function Footer() {
  return (
    <div className='footer'>
      <div className='bottom_wave svg3'></div>
      <div className='bottom_wave svg2'></div>
      <div className='bottom_wave svg1'></div>
      <div className='bottom_wave'>
        <footer className='footer'>
            <center><p>Made with ❤️ by 4 SFU CS clowns 🤡</p></center>
        </footer>
      </div>
    </div>
  )
}

export default Footer